import {Route} from '@angular/router';
import MarketAnalysisComponent from '@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/market-analysis.component';

export const marketAnalysisRoute : Route[] = [
  {
    path: '',
    component: MarketAnalysisComponent,
    children: [
      {
        path: '',
        redirectTo: 'macro-economic-overview',
        pathMatch: 'full'
      },
      {
        path: 'supply',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/pages/supply-analysis/supply-analysis.component'),
      },
      {
        path: 'infrastructure',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/pages/infrastructure/infrastructure.component'),
      },
      {
        path: 'demand',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/pages/demand-analysis/demand-analysis.component')
      },
      {
        path: 'demographic',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/pages/demographic/demographic.component')
      },
      {
        path: 'macro-economic-overview',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/pages/macro-economic-overview/macro-economic-overview.component')
      },
      {
        path: 'market-gap-outlook',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/market-analysis/pages/market-gap-outlook/market-gap-outlook.component'),
      },
    ]
  }
];
